module.exports = __webpack_public_path__ + "img/svg/plus.07a062cad817b32be7a11f7e793732cf.svg";